import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { RESTDataSource } from "@apollo/datasource-rest";
import config from "@/lib/config";
import { v4 as uuidv4 } from "uuid";
class PinManager extends RESTDataSource {
  constructor(options) {
    super(options);
    _defineProperty(this, "baseURL", config.api.vcmsURL);
    this.context = options;
  }
  willSendRequest(_path, request) {
    var _this$context$req;
    if ((_this$context$req = this.context.req) !== null && _this$context$req !== void 0 && _this$context$req.userToken) {
      const {
        id,
        accessToken
      } = this.context.req.userToken;
      request.headers["X-Token-Id"] = id;
      request.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const requestId = uuidv4();
    request.headers["X-Spoox-Web-Session-Request-Id"] = requestId;
    const userId = request.headers["X-User-Id"];
    console.log(`[${requestId}][Session][REQUEST INFO] Method: ${request.method}, Path: ${_path}, UserId: ${userId}`);
  }
  async didReceiveResponse(response, request) {
    const requestId = request.headers["X-Spoox-Web-Session-Request-Id"];
    console.log(`[${requestId}][Session][RESPONSE INFO] Status: ${response.status}`);
    return super.didReceiveResponse(response, request);
  }
  async pinActivate(code) {
    // TVデバイスのアクティベーションコードの認証
    const params = {
      pin_code: code
    };
    return this.post("/pin/activate", {
      body: params
    });
  }
}
export default PinManager;